module.exports = __webpack_public_path__ + "img/await.7e38ee42.png";